import { createContext } from 'react';
// @ts-ignore
export const DeckGlContext = createContext();
//# sourceMappingURL=deckgl-context.js.map